import Carousel from './components/Carousel.js';
import Drawer from './components/Drawer.js';
import Form from './components/form.js';
import Header from './components/Header.js';
import Youtube from './components/Youtube.js';
import Scrolly from './components/Scrolly.js';
export default class ComponentFactory {
  constructor() {
    this.componentList = {
      Carousel,
      Header,
      Scrolly,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');
    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;
      console.log(componentName);

      if (this.componentList[componentName]) {
        new this.componentList[componentName](element);
      } else {
        console.log(`La composante ${componentName} n'existe pas!`);
      }
    }
  }
}
